import { Layout, Avatar, Dropdown, Menu, Button } from 'antd';
import { UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';

const { Header } = Layout;
const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
        localStorage.removeItem('userName');
        localStorage.removeItem('accessToken');// hoặc remove token
        window.location.reload(); // hoặc điều hướng về /login
    }
};
const userMenu = (
    <Menu onClick={handleMenuClick}>
        <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
            Đăng xuất
        </Menu.Item>
    </Menu>
);
const AppHeader = () => {
    const user = localStorage.getItem('userName');
    return (
        <Header style={{
            background: '#e3e2e2',
            padding: '0 24px',
            borderBottom: '1px solid #f0f0f0',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}>

        <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%',
            }}>
                <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                    🚀 Hệ thống tích hợp VDG
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar style={{ backgroundColor: '#1890ff' }} icon={<UserOutlined />} />
                    <Dropdown overlay={userMenu} placement="bottomRight">
                        <Button type="text" style={{ marginLeft: 8 }}>
                            {user} <DownOutlined />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </Header>
    );
};

export default AppHeader;
